<div class="container">
  <section class="tariffs">
    <div class="main-title_secondary">Тарифы</div>
    <div class="tariffs-subtitle">BusyFly — единственный сервис кикшеринга, в котором существуют тарифы по скорости
      катания.
    </div>
    <div class="tariffs-container">
      <ng-container *ngFor="let tariff of tariffs">
        <div class="tariffs-item">
          <div class="tariffs-item-title">{{tariff.title}}</div>
          <div class="tariffs-item-speed">{{tariff.speed}}<br>{{tariff.measure}}</div>
          <div class="tariffs-item-price"><span class="tariffs-item-price-text">от</span> {{tariff.price}} <span
            class="tariffs-item-price-text_secondary">{{tariff.currency}} </span></div>
        </div>
      </ng-container>
    </div>
    <div class="tariffs-note">Тарифы зависят от страны, региона, дня недели и времени суток.</div>
  </section>
</div>
